import api from './api';

export const salesService = {
    getAllSalesInvoices: (params) => api.get('/sales', { params }),
    getSalesStats: (params) => api.get('/sales/stats', { params }),
    getSalesInvoice: (id) => api.get(`/sales/${id}`),

    createSalesInvoice: (data) => api.post('/sales', data),

    getNextInvoiceNumber: (companyId) => api.get('/sales/next-number', { params: { companyId } }),

    // Placeholder for update if implemented later
    updateSalesInvoice: (id, data) => api.put(`/sales/${id}`, data),

    exportSalesInvoice: (id) => api.get(`/sales/${id}/export`, { responseType: 'blob' }),
    deleteSalesInvoice: (id) => api.delete(`/sales/${id}`),
};
